var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50742 10.089C8.73672 10.089 8.95416 9.99484 9.11394 9.81747L16.771 1.86808C16.9189 1.71622 17.01 1.53221 17.01 1.30597C17.01 0.852598 16.6662 0.5 16.2128 0.5C15.9993 0.5 15.7858 0.592017 15.6379 0.731102L8.01843 8.62932H8.99155L1.36808 0.731102C1.22413 0.592017 1.02431 0.5 0.805962 0.5C0.34862 0.5 -2.55613e-08 0.852598 -5.84279e-08 1.30597C-7.4829e-08 1.53221 0.0950696 1.72019 0.242961 1.87203L7.90485 9.82142C8.06947 9.99879 8.26929 10.089 8.50742 10.089Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.6c166a39b7317b79ffe3a976e3a40e69.svg";
export { ForwardRef as ReactComponent };